import React from "react"
import {gsap,Power2} from "gsap";
import Header from "../components/Header";
import customNav from "../components/customNav";
import ScrollSVG from "../../static/svg/scroll.inline.svg";
import LocomotiveScroll from 'locomotive-scroll';
import { CSSRulePlugin } from "gsap/CSSRulePlugin"
import underline from "../images/underline-4.png";
var FontFaceObserver = require('fontfaceobserver');
gsap.registerPlugin(CSSRulePlugin);


//nav
let siteNav = new customNav();

class Layout extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            firstAppLoad : true
        };


    }

    componentDidMount() {
        if (typeof window !== "undefined") {

            document.addEventListener(
                'gesturestart', (e) => e.preventDefault()
            );

            //APP FIRST LOAD
            this.state.firstAppLoad = false;
            var iner = 0;
            if (window.matchMedia('(min-width:992px)').matches) {
                var iner = 0.5;
            }
            //INIT SCROLL
            window.ss = new LocomotiveScroll({
                el: document.querySelector('[data-scroll-container]'),
                smooth: true,
                inertia: iner,
                passive: true,
                getSpeed: true,
                touchMultiplier: 3,
                smartphone: { smooth: true },
                tablet: { smooth: true }
            });

            //LAYOUT MONTATO
            console.log('layout montato');
            window.dispatchEvent(new Event('documentReady'));

            //PRELOAD ASSETS
            /*
            const preloadImages = new Promise((resolve, reject) => {
                imagesLoaded(document.querySelectorAll("img"), { background: true }, resolve);
            });
            */
            const fontGal = new Promise(resolve => {
                new FontFaceObserver("Gallient").load().then(() => {
                    resolve();
                });
            });
            const fontAeo = new Promise(resolve => {
                new FontFaceObserver("Aeonik").load().then(() => {
                    resolve();
                });
            });

            let allDone = [fontGal,fontAeo];

            Promise.all(allDone).then(()=>{

                window.dispatchEvent(new Event('fontsLoaded'));
                console.log('fonts loaded');

            });

            //DARK MODE
            document.getElementById('site__mode').addEventListener('click',function (e) {

                e.preventDefault();
                var tl = new gsap.timeline();
                var pseudo = CSSRulePlugin.getRule(".text u:before");
                var pseudo2 = CSSRulePlugin.getRule(".home__mlist-title:before");

                if (document.getElementById('site__mode').classList.contains('dark')) {
                    document.getElementById('site__mode').classList.remove('dark');




                    tl.add('start')
                        .to('body',{
                            background: '#FAFAF8',
                            color: '#363636',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')
                        .to('.home__title',{
                            color: '#363636',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')
                        .to('a:not(.site__navbar-link)',{
                            color: '#000',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')
                        .to(pseudo,{
                            cssRule: {
                                "background-color": '#363636',
                                ease: Power2.easeInOut,
                                duration: '0.6'
                            },

                        },'start')
                        .to(pseudo2,{
                            cssRule: {
                                "background-color": '#363636',
                                ease: Power2.easeInOut,
                                duration: '0.6'
                            },

                        },'start')
                        .to('.m-projects__pg',{
                            fill: '#363636',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')
                        .to('i',{
                            color: '#363636',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')
                        .to('.home__list li',{
                            "border-color": '#363636',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')
                        .add(function () {
                            document.querySelectorAll('.home__list li a').forEach(el =>{
                                el.classList.remove('dark');
                            })
                        },'start')
                        .add(function () {
                            document.querySelectorAll('.about__list li a').forEach(el =>{
                                el.classList.remove('dark');
                            })
                        },'start')
                        .add(function () {
                            document.querySelector('.site__mode').classList.remove('dark');
                        },'start')
                        .to('.home__list a svg g',{
                            "fill": '#363636',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')
                        .to('.about__list a svg path',{
                            "fill": '#363636',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')
                        .to('.project-svg path',{
                            "fill": '#363636',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')

                        .add(function () {
                            document.querySelector('body').classList.remove('dark-mode');
                        })


                } else {
                    document.getElementById('site__mode').classList.add('dark');




                    tl.add('start')
                        .to('body',{
                            background: '#181618',
                            color: '#e6e6e6',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')
                        .to('.home__title',{
                            color: '#e6e6e6',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')
                        .to('a:not(.site__navbar-link)',{
                            color: '#FFF',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')
                        .to('.m-projects__pg',{
                            fill: '#e6e6e6',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')
                        .to(pseudo,{
                            cssRule: {
                                "background-color": '#e6e6e6',
                                ease: Power2.easeInOut,
                                duration: '0.6'
                            },

                        },'start')
                        .to(pseudo2,{
                            cssRule: {
                                "background-color": '#e6e6e6',
                                ease: Power2.easeInOut,
                                duration: '0.6'
                            },

                        },'start')
                        .to('i',{
                            color: '#181618',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')
                        .to('.home__list li',{
                            "border-color": '#6a6a6a',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')
                        .add(function () {
                            document.querySelectorAll('.home__list li a').forEach(el =>{
                                el.classList.add('dark');
                            })
                        },'start')
                        .add(function () {
                            document.querySelectorAll('.about__list li a').forEach(el =>{
                                el.classList.add('dark');
                            })
                        },'start')
                        .add(function () {
                            document.querySelector('.site__mode').classList.add('dark');
                        },'start')
                        .to('.home__list a svg g',{
                            "fill": '#e6e6e6',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')
                        .to('.about__list a svg path',{
                            "fill": '#e6e6e6',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')
                        .to('.project-svg path',{
                            "fill": '#e6e6e6',
                            ease: Power2.easeInOut,
                            duration: '0.6'
                        },'start')

                        .add(function () {
                            document.querySelector('body').classList.add('dark-mode');
                        })
                }












            });






        }
    }

    


    render() {
        //console.log('render layout');
        let firstAppLoad = this.state.firstAppLoad;
        return(
            <>
                <Header siteTitle="Home" navi={siteNav} />
                <div className="noise-bg"></div>
                <div className={'site__canvas-wrap'}>
                    <div className={'site__canvas'}></div>
                </div>
                <main>
                    <div data-scroll-container>{React.Children.map(this.props.children, (child) =>
                        React.cloneElement(child, { firstAppLoad })
                    )}</div>
                </main>
                <a className="site__scroll" href="http://127.0.0.1:8000/">
                    <ScrollSVG />
                </a>
                <div className="smode">
                    <a id="site__mode" className="site__mode site__navbar-link" href="http://127.0.0.1:8000/">
                        <strong className="d">DARK MODE</strong>
                        <strong className="l">LIGHT MODE</strong><span></span>
                    </a>
                    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 147 6"
                         data-animated-mark="underline-4" data-js-module="" className="draw">
                        <defs>
                            <pattern id="underline-4" patternUnits="userSpaceOnUse" width="100%" height="100%">
                                <image xlinkHref={underline}></image>
                            </pattern>
                        </defs>
                        <path fill="none" stroke="url(#underline-4)" className="todraw" strokeWidth="6" d="M-2.3,3C48.3,3.1,98.9,3.1,149.5,3.2"></path>
                    </svg>
                </div>

            </>
        )
    }
}

export default Layout